module.exports = __webpack_public_path__ + "media/img/event/ohana-banner-2-070440749564ab1904727218492447f2.jpg";